import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/link';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { isRetinaDisplay, isWindows } from 'utils/environment';
import { sendEventToGA } from 'utils/googleAnalytics';
import { options } from 'config/reactRedux';
import getIsInProductMagazine from 'selectors/getIsInProductMagazine';

import styles from './callToAction.css';

const arrow = (
  <svg className={styles.arrowIcon} fill="none" height="43" viewBox="0 0 54 43" width="54" xmlns="http://www.w3.org/2000/svg">
    <path clipRule="evenodd" d="M13.0449 7.16793L19.4665 8.0307C22.932 8.70055 27.8903 10.6162 30.9329 12.3285L35.8699 15.2084C40.4052 18.1665 44.8768 24.0174 47.5258 29.0707C47.9063 29.9568 52.94 40.0416 53.1199 40.9667C53.3357 42.0769 52.5107 43.1976 51.1976 42.877C49.9205 42.7414 49.7049 41.6312 49.2885 40.5601C48.8001 39.1189 42.8762 27.6711 41.7852 26.3472C39.6964 23.1051 36.969 19.7952 33.6537 17.7519C30.3384 15.7087 29.5921 15.0858 25.9468 13.4907C23.9233 12.7323 22.1367 12.1198 20.1132 11.3614C17.4871 10.7202 9.38657 9.80007 6.37339 10.3864L10.6719 13.1985C12.3295 14.2202 13.3127 14.989 15.0063 16.1957C17.4462 18.0252 19.1039 19.0469 21.343 20.9155C23.3452 22.6383 20.8922 25.0359 18.9259 23.4982C14.9573 20.2378 8.38382 15.372 3.92039 12.784C2.77228 12.2393 0.203309 10.8189 0.116752 9.29949C0.102055 8.15017 0.632828 7.66284 1.80217 7.24327C2.80657 7.04783 3.70318 6.29727 4.67164 5.9168L17.8431 1.8176C20.3827 0.939382 22.6642 0.87949 25.1107 0.595472C26.5168 0.321856 27.5212 0.126415 28.1026 0.973426C30.3205 3.80636 23.5477 4.35612 20.3696 5.16656C17.995 5.82065 15.3836 6.3288 13.0449 7.16793Z" fill="white" fillRule="evenodd" />
  </svg>
);

const CallToAction = ({
  isBig,
  isInFooter,
  isInHeader,
  shouldHide,
  heading,
  url,
  text,
}) => {
  if (shouldHide) {
    return null;
  }

  return (
    <div className={isBig ? styles.wrapper : null}>
      {heading &&
        <div className={isInFooter ? styles.altHeading : styles.heading}>
          {heading}
        </div>}
      <div className={isInFooter ? styles.altLinkContainer : styles.linkContainer}>
        <Link
          className={classNames(styles.link, {
            [styles.isBig]: isBig,
            [styles.isInFooter]: isInFooter,
            [styles.isInHeader]: isInHeader,
            [styles.isWindowsNonRetina]: isWindows() && !isRetinaDisplay(),
          })}
          to={url}
          onClick={() => (isBig ? sendEventToGA('article_cta_button') : sendEventToGA('try_babbel_button'))}
        >
          {text}
        </Link>
        {isInFooter && arrow}
      </div>
    </div>
  );
};

CallToAction.propTypes = {
  isBig: PropTypes.bool,
  isInFooter: PropTypes.bool,
  isInHeader: PropTypes.bool,
  shouldHide: PropTypes.bool.isRequired,
  heading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  url: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
};

CallToAction.defaultProps = {
  isBig: false,
  isInFooter: false,
  isInHeader: false,
  heading: '',
};

const mapStateToProps = (state) => ({
  shouldHide: getIsInProductMagazine(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

export default withRedux(withStyles(styles)(CallToAction));
